import React from "react";

const Spacer = ({ width = 24, height = 24, }) => {
    return <div style={{width, height}}/>
}

export default Spacer
